<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <div class="auth-wrapper auth-v2">

      <b-row class="auth-inner m-0">
        <!-- Brand logo-->
        <!--        <b-link class="brand-logo">-->
        <!--          &lt;!&ndash;                <img src='@/assets/images/logo/logo_cw_72px.png' alt="Logo" />&ndash;&gt;-->
        <!--          &lt;!&ndash;                  <h2 class="brand-text text-primary ml-1">&ndash;&gt;-->
        <!--          &lt;!&ndash;                    Comextweb Aranceles&ndash;&gt;-->
        <!--          &lt;!&ndash;                  </h2>&ndash;&gt;-->
        <!--          <b-img-->
        <!--            :src="`${isDark ? appLogoImageDark : appLogoImageLight}`"-->
        <!--            alt="logo"-->
        <!--          />-->
        <!--        </b-link>-->
        <!-- /Brand logo-->

        <!-- Left Text-->
        <b-col
          lg="8"
          class="d-none d-lg-flex align-items-center"
        >
          <div class="w-100 d-lg-flex align-items-center justify-content-center fixing-padding-login">
            <b-img-lazy
              fluid
              :src="require('@/assets/images/logo/lobitozz_new_image_login.jpg')"
              alt="Login V2"
              class="imagen-logo-custom"
            />
          </div>
        </b-col>
        <!-- /Left Text-->

        <!-- Login-->
        <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-5"
        >
          <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
          >
            <b-img
              fluid
              :src="require('@/assets/images/logo/logo_lb_36px.png')"
              alt="logo"
              class="d-flex align-items-center auth-bg px-2 p-lg-5"
            />
            <b-card-title
              title-tag="h2"
              class="font-weight-bold mb-1"
            >
              Bienvenido/a 👋
            </b-card-title>
            <validation-observer ref="loginValidation">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
              >
                <!-- email -->
                <b-form-group
                  label="Usuario"
                  label-for="login-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    rules="required"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false:null"
                      name="login-email"
                      placeholder="john@example.com"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">Contraseña</label>
<!--                    <b-link :to="{name:'forgot-password'}">-->
                      <small>¿Olvidó su contraseña?</small>
<!--                    </b-link>-->
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <b-input-group
                      label="Contraseña"
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false:null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  @click="validationForm"
                >
                  Ingresar
                </b-button>
              </b-form>
            </validation-observer>
          </b-col>
        </b-col>
        <!-- /Login-->
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BOverlay, BImgLazy,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// import { print } from 'graphql'
// import gql from 'graphql-tag'
import Vue from 'vue'
import rutasjson from '@/assets/utils/rutas.json'

import es from 'vee-validate/dist/locale/es.json'
import { $themeConfig } from '@themeConfig'
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api/dist/vue-composition-api'
import { request, GraphQLClient } from 'graphql-request'
import axios from '@/axios'

localize({
  es,
})

localize('es')


export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    // BFormCheckbox,
    // BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    BImgLazy,
  },
  setup() {
    // App Name
    const {
      appName, appLogoImageDark, appLogoImageLight, appLogoLobitozz,
    } = $themeConfig.app
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return {
      appName,
      appLogoImageDark,
      appLogoImageLight,
      appLogoLobitozz,
      skin,
      isDark,
    }
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      graphQLClient: new GraphQLClient(`${rutasjson.ruta}api`, {
        // credentials: 'include',
      }),
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  mounted() {
    this.graphQLClient = new GraphQLClient(`${rutasjson.ruta}api`, {
      // credentials: 'include',
    })
  },
  methods: {
    validationForm() {
      console.log('Iniciando validacion form')
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.login()
        }
      })
    },

    login() {
      const mutation = `mutation tokenAuth($username: String!, $password: String!){
                          tokenAuth(username:$username, password:$password){
                            token
                            user{
                                username
                                email
                                firstName
                                lastName
                            },
                            detalleUsuario{
                                token
                                avatar
                                celular
                                avatarruta
                            }
                            permisos
                          }
                        }`
      this.graphQLClient.request(mutation, { username: this.userEmail, password: this.password }).then(data => {
        data.tokenAuth.user.token = data.tokenAuth.token
        axios.defaults.headers.common.Authorization = `JWT ${data.tokenAuth.token}`
        localStorage.setItem('permisos', JSON.stringify(data.tokenAuth.permisos))
        localStorage.setItem('detalleusuario', JSON.stringify(data.tokenAuth.detalleUsuario))
        localStorage.setItem('usuario', JSON.stringify(data.tokenAuth.user))
        this.$router.push({name: 'home'})
      }).catch(error => {
        this.showError(error)
        this.loading = false
      })
    },

    showError(error) {
      const error_dict = JSON.parse(JSON.stringify(error))
      if (error_dict.response.errors.length > 0) {
        const errores = error_dict.response.errors
        if (errores) {
          this.$swal({
            title: 'Error!',
            text: errores[0].message,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
            confirmButtonText: 'Aceptar',
          })
        }
      } else {
        this.$swal({
          title: 'Error!',
          text: 'Ocurrió un error, intente nuevamente.',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
          confirmButtonText: 'Aceptar',
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
